import Picker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import clsx from "clsx";
import { Controller } from "react-hook-form";
import { InputFieldMessage } from "components/elements";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  control: Control<any>;
  name: string;
  label?: string;
  errorText?: string | null;
  classNames?: string;
  dateFormat?: string;
  showMonthYearPicker?: boolean;
  showYearDropdown?: boolean;
  pickerClass?: string;
  isDisabled?: boolean;
  removeBackground?: boolean;
};
export const DatePickerForm = ({
  control,
  name,
  errorText,
  label,
  pickerClass,
  classNames,
  dateFormat,
  showYearDropdown = true,
  showMonthYearPicker = false,
  isDisabled = false,
  removeBackground = false,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        errorText ? "datepicker-error" : "mb-7",
        removeBackground && "date-picker-remove-bg",
        classNames && classNames
      )}
    >
      <label className="text-[18px] text-[#333333] block font-dmSans pb-1 dark:text-white">
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <Picker
            ref={ref}
            placeholderText={t("select_date")}
            onChange={(date) => onChange(date)}
            selected={value}
            className={clsx(
              "outline-none dark:!bg-darkGray dark:!text-white",
              pickerClass && pickerClass
            )}
            calendarStartDay={1}
            // showMonthDropdown={showMonthDropdown}
            showYearDropdown={showYearDropdown}
            dropdownMode="select"
            dateFormat={dateFormat || "dd.MM.yyy"}
            showMonthYearPicker={showMonthYearPicker}
            disabled={isDisabled}
            wrapperClassName={"dark:!bg-darkGray"}
          />
        )}
      />
      {errorText && <InputFieldMessage text={errorText} />}
    </div>
  );
};
